import OperationalAssistantPanel from '../../../components/OperationalAssistant/OperationalAssistantPanel';
import './OperationalAssistantPage.css';

function OperationalAssistantPage() {
  return (
    <div className="operational-assistant-page-wrap">
      <OperationalAssistantPanel variant="page" />
    </div>
  );
}

export default OperationalAssistantPage;
